export default class ProfileController {

  constructor(app) {
    this.app = app;
    this.pageId = "Profile";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;
    const showLogin = app.portal?.autoLogin === false;
    model = {
      userdata: app.userdata,
      resource: app.resource,
      showLogin: showLogin
    };

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  async deleteAll() {
    const app = this.app;

    //crazy games clear userdata
    app.portal.delete();

    //this.userdata = {id:this.userdata.id};
    app.userdata = {
      name: null,
      email: null,
      avatar: null,
      coins: 0
    };
    await app.save(app.userdata, true);

    app.navigate("Loading");
    //todo: chagne to app.init (not created yet)
    await app.loadData(); //could have portal data to load as default and laodData pulls it
    //app.dataLoaded();
    //app.navigate("MainMenu");

  }
  // applyPromoCode(code) {
  //   const pageId = this.pageId;
  //   const app = this.app;

  //   if (!code) return;
  //   let message = app.items.applyPromoCode(code, app.userdata);

  //   app.createNotification(message);
  //   app.save(app.userdata, true);
  //   app.populate(pageId, app);
  // }
  submitProfile() {
    const app = this.app;
    const userdata = app.userdata;

    let txtName = document.getElementById("txtName");
    if (txtName) {
      userdata.name = txtName.value;
    }
    let txtEmail = document.getElementById("txtEmail");
    if (txtEmail) {
      userdata.email = txtEmail.value;
    }
    let cbDebug = document.getElementById("cbDebug");
    if (cbDebug) {
      app.debug = cbDebug.checked;
    }
    let cbBlockChat = document.getElementById("cbBlockChat");
    if (cbBlockChat) {
      userdata.isChatMuted = cbBlockChat.checked;
    }
    let cbIsMuted = document.getElementById("cbIsMuted");
    if (cbIsMuted) {
      userdata.isMuted = cbIsMuted.checked;
    }
    let cbCanvas = document.getElementById("cbCanvas");
    if (cbCanvas) {
      userdata.useCanvas = cbCanvas.checked;
    }
    let rdLanguageChecked = document.querySelector('input[name="rdLanguage"]:checked');
    if (rdLanguageChecked) {
      userdata.language = rdLanguageChecked.value;
      app.resource = app.localization.getResource(userdata.language);

    }
    let txtServerUrl = document.getElementById("txtServerUrl");
    if (txtServerUrl) {
      userdata.serverUrl = txtServerUrl.value;
    }
    app.save(userdata, true);
  }
}
